import { yupResolver } from "@hookform/resolvers/yup";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import { useState, useEffect } from "@wordpress/element";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { submitLogin, resetLoginState } from "store/auth/loginSlice";
import clsx from "clsx";
import { TextField, Button } from "vino/core";
import * as yup from "yup";
import _ from "lodash";

/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
	email: yup
		.string()
		.email("Please enter a valid email")
		.required("Please enter a email"),
	password: yup.string().required("Please enter your password."),
});

const defaultValues = {
	email: "",
	password: "",
};

function LoginForm({ redirectUrl }) {
	const dispatch = useDispatch();
	const login = useSelector(({ auth }) => auth.login);

	const methods = useForm({
		mode: "onChange",
		defaultValues,
		resolver: yupResolver(schema),
	});
	const { handleSubmit } = methods;

	const [showPassword, setShowPassword] = useState(false);

	function onSubmit(model) {
		dispatch(submitLogin(model, redirectUrl));
	}

	useEffect(() => {
		dispatch(resetLoginState());
	}, [dispatch]);

	return (
		<div className="w-full">
			<FormProvider {...methods}>
				<form
					noValidate
					className="flex flex-col justify-center w-full"
					onSubmit={handleSubmit(onSubmit)}
				>
					<div className="mb-16">
						<TextField
							name="email"
							type="text"
							label="Email"
							fullWidth
							required
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<Icon className="fa-solid fa-user text-20" color="action" />
									</InputAdornment>
								),
							}}
							variant="outlined"
						/>
					</div>
					<div>
						<TextField
							name="password"
							label="Password"
							type="password"
							variant="outlined"
							fullWidth
							InputProps={{
								className: "pr-2",
								type: showPassword ? "text" : "password",
								endAdornment: (
									<InputAdornment position="end">
										<Icon
											onClick={() => setShowPassword(!showPassword)}
											className={clsx(
												"cursor-pointer text-20 fa-solid",
												showPassword ? "fa-eye" : "fa-eye-slash"
											)}
											color="action"
										/>
									</InputAdornment>
								),
							}}
							required
						/>
					</div>
					{login.error && (
						<div className="mt-16">
							<Typography color="red">The login detail is incorrect</Typography>
						</div>
					)}
					<div className="flex justify-center mt-16">
						<Button
							type="submit"
							className="w-full"
							value="legacy"
							isSubmitting={login.isSubmitting}
						>
							Login
						</Button>
					</div>
				</form>
			</FormProvider>
		</div>
	);
}

export default LoginForm;
